var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VContainer',{staticClass:"page__auth__complete-profile"},[_c('AuthCompleteProfile',{attrs:{"doctor-service":_vm.doctorService}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }